var map = {
	"./co_creation_card_bg.png": 84824,
	"./explore_item_bg.png": 90046,
	"./good_case_bg.png": 28859,
	"./growth_bg.png": 93091,
	"./innovations_bg.png": 26247,
	"./login-right-logo.png": 53734,
	"./open_platform_bg.png": 84149,
	"./open_platform_card.png": 52810,
	"./project_bg.png": 51295,
	"./sustainable_bg.png": 80429,
	"./sustainable_mission.png": 26210,
	"./sustainable_orientation.png": 77092,
	"./sustainable_vision.png": 80228,
	"./tool1.png": 73619,
	"./tool2.png": 32178,
	"./tool3.png": 79979,
	"./tool4.png": 81299,
	"./toolbox-card-bg.png": 61766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68438;